export default __webpack_public_path__ + "static/media/network_error.f56832eb.svg";